import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Shell from "@/components/Shell";

export default function PaymentCancel() {
  return (
    <Shell>
      <div className="max-w-xl mx-auto brutal-border bg-[#141414] p-10 text-center" data-testid="payment-cancel-card">
        <XCircle size={48} className="text-muted-foreground mx-auto mb-4" />
        <h1 className="font-heading font-black text-3xl mb-2">Checkout cancelled.</h1>
        <p className="text-muted-foreground mb-6">No charge was made. You can pick a plan whenever you're ready.</p>
        <Link to="/pricing" data-testid="cancel-back-pricing" className="cta-primary inline-block px-5 py-3 font-mono-label text-xs">Back to Pricing</Link>
      </div>
    </Shell>
  );
}
